module.exports = __webpack_public_path__ + "img/gear.f1fde82e.svg";